import { getAuth } from "firebase/auth";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken";
import { auth } from "../../config/FirebaseConfig";

const uploadDropZoneTemporary = async (bytes, filename, prefix) => {
  try {
    const url = prefix + "upload/dropzone-temporary";
    // Create a new FormData object
    const formData = new FormData();

    formData.append("file", new Blob([bytes]), filename);

    const token = await getOrRefreshFirebaseToken();

    // Send the request with the file and token
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    if (response.ok) {
      // Read the response body as JSON
      const jsonResponse = await response.json();
      const data = jsonResponse.data;

      const url = data.url;
      const name = data.name;

      return { url, name };

      // Trigger the onDrop callback with the URL and name
    } else {
      console.error(`Error response for file ${filename}: ${response.status}`);
    }
  } catch (error) {
    console.error("Error selecting/uploading files:", error);
  }
};

export default uploadDropZoneTemporary;
